module.exports = __webpack_public_path__ + "img/FooterBangunHusada.e812c13c.png";